module.exports = {
    config: {
        suppressEmptyTemplates: true,
        staticLookupName: 'navController',
    },
}